import findIndex from 'lodash/findIndex';
import UserModel from '../../../UserModel';

export const getDefaultAssignUserValue = ({ allowedRoles }) => {
    const isUserHasAllowedRole = findIndex(allowedRoles, (role) => UserModel.hasRole(role)) >= 0;
    return isUserHasAllowedRole ? UserModel.getUserId() : '';
};
